// extracted by mini-css-extract-plugin
export default {"card_heading":"teacher-leave-approval_card_heading__WGWR6","topBar":"teacher-leave-approval_topBar__m4w3S","tableWrapper":"teacher-leave-approval_tableWrapper__xXRj6"};